import { Api, LocalDictionaryFactory } from './../../../api/api.module'
import { PecGliwiceDataTypeGroupCreateEditPopupController } from './pec-gliwice-create-edit-popup.controller'

import { UserSessionService, USER_SESSION_SERVICE_NAME } from '../../../../services/user-session'
import { $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../../services/system'
import { ReferenceTypeService, REFERENCE_TYPE_SERVICE_NAME } from '../../../../services/reference-type'
import { OperatorSecurityService, OPERATOR_SECURITY_SERVICE_NAME } from '../../../../services/operator'

//#region Asset Imports

import './pec-gliwice-create-edit-popup.scss'
import * as TEMPLATE from './pec-gliwice-create-edit-popup.tpl.html'

//#endregion

export class PecGliwiceDataTypeGroupCreateEditPopupDirective implements ng.IDirective {
	constructor() {}

	restrict = 'E'
	scope = {
		options: '=',
	}

	controller = [
		$SCOPE_SERVICE_NAME,
		$Q_SERVICE_NAME,
		$TIMEOUT_SERVICE_NAME,
		'api',
		'localDictionary',
		USER_SESSION_SERVICE_NAME,
		REFERENCE_TYPE_SERVICE_NAME,
		OPERATOR_SECURITY_SERVICE_NAME,
		(
			$scope,
			$q: ng.IQService,
			$timeout: ng.ITimeoutService,
			api: Api,
			localDictionary: LocalDictionaryFactory,
			userSession: UserSessionService,
			referenceTypeService: ReferenceTypeService,
			operatorSecurityService: OperatorSecurityService
		) => new PecGliwiceDataTypeGroupCreateEditPopupController($scope, $q, $timeout, api, localDictionary, userSession, referenceTypeService, operatorSecurityService),
	]

	template = TEMPLATE
	transclude = true
}
